exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-b44361ec]{display:flex;width:1.2307692308em;height:1.2307692308em;align-items:center;justify-content:center;background-color:transparent}.button[data-v-b44361ec]:hover{cursor:pointer}.button__icon[data-v-b44361ec]{flex:0 0 auto}.button[data-v-b44361ec]:focus:not(:focus-visible){outline:none}", ""]);

// exports
